import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import webProfitMark from "../../images/LogoWebProfit1.svg";

export default function WebProfitLoadingScreen({
  title = "Cargando WebProfit",
  description = "Preparando tu espacio de trabajo…",
  compact = false,
}) {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        minHeight: compact ? 280 : "100vh",
        width: "100%",
        display: "grid",
        placeItems: "center",
        px: 3,
        bgcolor: "#fff",
      }}
    >
      <Box sx={{ width: "min(360px, 86vw)", textAlign: "center" }}>
        <Box
          component="img"
          src={webProfitMark}
          alt=""
          aria-hidden="true"
          sx={{
            width: compact ? 54 : 68,
            height: compact ? 54 : 68,
            objectFit: "contain",
            animation: "wpLoaderSpin 1.55s cubic-bezier(.65,.05,.36,1) infinite",
            "@keyframes wpLoaderSpin": {
              "0%": { transform: "rotate(0deg) scale(.88)", opacity: 0.72 },
              "45%": { transform: "rotate(168deg) scale(1)", opacity: 1 },
              "100%": { transform: "rotate(360deg) scale(.88)", opacity: 0.72 },
            },
          }}
        />
        {title ? (
          <Typography sx={{ mt: 2, fontWeight: 900, color: "#19242f", fontSize: compact ? 16 : 18 }}>
            {title}
          </Typography>
        ) : null}
        {description ? (
          <Typography sx={{ mt: 0.6, color: "#65717d", fontSize: 13.5 }}>
            {description}
          </Typography>
        ) : null}
        <LinearProgress
          sx={{
            mt: 2.25,
            height: 5,
            borderRadius: 999,
            bgcolor: "rgba(243,90,58,.12)",
            "& .MuiLinearProgress-bar": { borderRadius: 999, bgcolor: "#f35a3a" },
          }}
        />
      </Box>
    </Box>
  );
}
